import { BaseResponse } from '../manager/handle_data/HandleData';
import { PaginationRequest } from '../types';
import apiService from './api.service';

export interface RewardDataType {
  id: number;
  name?: string;
  description?: string;
  icon?: string;
  rewardRefId?: number;
  total?: number;
  totalPaid?: number;
  display?: boolean;
}

export type RewardUpsertType = Partial<RewardDataType>;

class RewardService {
  async getAll(params?: PaginationRequest): Promise<BaseResponse<RewardDataType[]>> {
    const res = await apiService.get('b/reward', { params });
    const data = res?.data?.data || [];
    return data;
  }

  async getById(id: string): Promise<BaseResponse<RewardDataType>> {
    const res = await apiService.get(`/b/reward/${id}`);
    return res.data;
  }

  async create(data: RewardUpsertType): Promise<BaseResponse<RewardDataType>> {
    const res = await apiService.post('/b/reward', data);
    return res.data;
  }

  async update({ id, data }: { id: number; data: RewardUpsertType }): Promise<BaseResponse<RewardDataType>> {
    const res = await apiService.put(`/b/reward/${id}`, data);
    return res.data;
  }

  async delete(id: number): Promise<BaseResponse<RewardDataType>> {
    const res = await apiService.delete(`/b/reward/${id}`);
    return res.data;
  }
}

const rewardService = new RewardService();
export default rewardService;
